export enum ProximityPhase {
  MoveCloser,
  MoveFurther,
  TakeCloserImage,
  TakeFurtherImage,
  Complete,
}

export enum TurnDirection {
  Left = 0,
  Right = 1,
}

export default class ProximityTracker {
  phase: ProximityPhase;

  // represents the progress for each phase
  // the range is between 0.0 and 1.0
  // for Phase.CenterHead, it represents amout of time to center head
  // for Phase.TurnHead, it represents the distance head has been turned
  progress: number;
  closenessProgress;
  furthernessProgress;
  isCompleted = false;
  isFaceTooClose = false;
  isFaceTooFar = false;
  shouldFaceBeCentered = false;

  constructor() {
    this.phase = ProximityPhase.MoveFurther;
    this.progress = 0;
  }
  setPhase(phase: ProximityPhase) {
    this.phase = phase;
  }
  reset() {
    this.isCompleted = false;
    this.progress = 0;
    this.isFaceTooFar = false;
    this.isFaceTooClose = false;
  }
  isFaceFarEnough(scale: number) {
    if (scale < 0.41) {
      this.isFaceTooClose = false;
      this.isFaceTooFar = true;
    } else if (scale > 0.48) {
      this.isFaceTooClose = true;
      this.isFaceTooFar = false;
    } else {
      this.isFaceTooClose = false;
      this.isFaceTooFar = false;
      return scale > 0.41 && scale < 0.48;
    }
  }
  isFaceCloseEnough(scale: number) {
    if (scale < 0.48) {
      this.isFaceTooClose = false;
      this.isFaceTooFar = true;
    } else if (scale > 0.6) {
      this.isFaceTooClose = true;
      this.isFaceTooFar = false;
    } else {
      this.isFaceTooClose = false;
      this.isFaceTooFar = false;
      return scale > 0.48 && scale < 0.6;
    }
  }
  isFaceCentered(x: number, y: number) {
    return x > -0.2 && x < 0.2 && y > -0.2 && y < 0.2;
  }
  getProgress() {
    return this.progress;
  }
  updateProgress() {
    if (!(this.progress >= Math.PI * 2)) {
      this.progress = this.progress + Math.PI * 0.01;
    } else {
      this.isCompleted = true;
    }
  }
  update(xCoordinate: number, yCoordinate: number, faceScale: number) {
    const currentPhase = this.phase;
    if (this.isFaceCentered(xCoordinate, yCoordinate)) {
      this.shouldFaceBeCentered = false;
      if (currentPhase === ProximityPhase.MoveFurther) {
        if (this.isFaceFarEnough(faceScale)) {
          this.updateProgress();
        }
      } else if (currentPhase === ProximityPhase.MoveCloser) {
        if (this.isFaceCloseEnough(faceScale)) {
          this.updateProgress();
        }
      }
    } else {
      this.shouldFaceBeCentered = true;
    }
  }
}
